import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';

// Builds the `cfg` object api.js's fetch helpers expect, carrying the
// logged-in internal user's own JWT so the backend can apply its
// role-scoping (ADMIN sees everything; KAM/AE see only their own clients).
export function useApiConfig() {
  const { currentUser } = useAuth();
  return useMemo(() => (currentUser?.token ? { bearerToken: currentUser.token } : null), [currentUser]);
}
